import RelatedResourceCard from "./RelatedResourceCard"

export default RelatedResourceCard
